import React from 'react';
import PropTypes from 'prop-types';

import { Wrap, CartContent } from './styled';

const Desktop = ({ className, handleMouseEnter, handleMouseLeave }) => (
    <Wrap
        className={className}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        data-testid="desktop-overlay"
    >
        <CartContent />
    </Wrap>
);

Desktop.propTypes = {
    className: PropTypes.string,
    handleMouseEnter: PropTypes.func,
    handleMouseLeave: PropTypes.func,
};

Desktop.defaultProps = {
    className: '',
    handleMouseEnter: () => {},
    handleMouseLeave: () => {},
};

export default Desktop;
